import { render } from "./assessment-v1-overlay.vue?vue&type=template&id=05796a19&scoped=true"
import script from "./assessment-v1-overlay.vue?vue&type=script&lang=js"
export * from "./assessment-v1-overlay.vue?vue&type=script&lang=js"

import "./assessment-v1-overlay.vue?vue&type=style&index=0&id=05796a19&lang=sass&scoped=true"

import exportComponent from "../../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05796a19"]])

export default __exports__